import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { useSelector } from 'react-redux';
import type { IAppState } from '../core/redux/IAppState';
import { LOGIN_ROUTE } from '../core/routes';

export default function PrivateRoute() {
  const location = useLocation();
  const { isAuthenticated, error, user } = useAuth0();

  const isLoggedIn = useSelector((s: IAppState) => s.auth.isLoggedIn);
  const username = useSelector((s: IAppState) => s.auth.username);
  const userState = useSelector((s: IAppState) => s.userState);

  const authed =
    (!!isAuthenticated && !!(user?.sub || user?.email)) ||
    (!!isLoggedIn && !!username);

  const hasUserProfile = !!userState?.firstName;

  // Error from Auth0 - route to login
  if (error) {
    return (
      <Navigate
        to={LOGIN_ROUTE}
        replace
        state={{ from: location, at: new Date().toISOString(), error: error.message }}
      />
    );
  }

  return authed && hasUserProfile ? (
    <Outlet />
  ) : (
    <Navigate
      to={LOGIN_ROUTE}
      replace
      state={{ from: location, at: new Date().toISOString() }}
    />
  );
}
